var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
const useAsyncAction = (action, dependencies = []) => {
    const dispatch = useDispatch();
    const unmounted = useRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);
    const [error, setError] = useState(false);
    const asyncAction = useCallback((...args) => {
        function callback() {
            return __awaiter(this, void 0, void 0, function* () {
                setIsLoading(true);
                try {
                    const res = yield dispatch(action(...args));
                    if (!unmounted.current) {
                        setIsLoading(false);
                        if (res === null || res === void 0 ? void 0 : res.error) {
                            setIsError(true);
                            setIsSuccessful(false);
                            setError(res);
                        }
                        else {
                            setIsError(false);
                            setIsSuccessful(true);
                            setError(false);
                        }
                    }
                    return res;
                }
                catch (e) {
                    if (!unmounted.current) {
                        setIsLoading(false);
                        setIsSuccessful(false);
                        setIsError(true);
                        setError(e);
                    }
                    return e;
                }
            });
        }
        callback();
    }, [action]);
    useEffect(() => {
        if (!unmounted.current) {
            setIsLoading(false);
            setIsSuccessful(false);
            setIsError(false);
        }
    }, [...dependencies]);
    useEffect(() => {
        unmounted.current = false;
        return () => {
            unmounted.current = true;
        };
    }, []);
    return { asyncAction, isLoading, isSuccessful, isError, setIsLoading, setIsError, setIsSuccessful, error };
};
export default useAsyncAction;
